<div class="row">
    <div class="col-sm-12 col-md-12" *ngIf="complianceItem.IsPreview">
            <div class="alert alert-info"><base-item-status-indicator [status]="ItemStatusIndicator.PREVIEW"></base-item-status-indicator> This item is in Preview mode. It is visible to supervisors now and will be published and accessible to all assigned users on {{complianceItem.PublishDate | date: 'MM/dd/yyyy'}}.</div>
        </div>
    <div [ngClass]="getColumnWidths()">
        <div class="row">
            <div [ngClass]="printMode ? 'col-4' : 'col-sm-12'">
                <strong>Cycle Progress:</strong>
                <div *ngIf="!printMode" class="progress">
                    <div class="progress-bar bg-success" role="progressbar" [style.width]="sanitizer.bypassSecurityTrustStyle(((complianceItem.ApprovedCount / complianceItem.TotalUserCount) * 100) + '%')" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'Approved: ' + complianceItem.ApprovedCount"></div>
                    <div class="progress-bar" role="progressbar" [style.width]="sanitizer.bypassSecurityTrustStyle(((complianceItem.PendingCount / complianceItem.TotalUserCount) * 100) + '%')" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'Pending: ' + complianceItem.PendingCount"></div>
                    <div class="progress-bar bg-yellow" role="progressbar" [style.width]="sanitizer.bypassSecurityTrustStyle(((complianceItem.ExpiringCount / complianceItem.TotalUserCount) * 100) + '%')" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'Expiring: ' + complianceItem.ExpiringCount"></div>
                    <div class="progress-bar bg-danger" role="progressbar" [style.width]="sanitizer.bypassSecurityTrustStyle(((complianceItem.ExpiredCount / complianceItem.TotalUserCount) * 100) + '%')" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'Expired: ' + complianceItem.ExpiredCount"></div>
                    <div class="progress-bar bg-dark text-white" role="progressbar" [style.width]="sanitizer.bypassSecurityTrustStyle(((complianceItem.DisapprovedCount / complianceItem.TotalUserCount) * 100) + '%')" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'Disapproved: ' + complianceItem.DisapprovedCount"></div>
                    <div class="" role="progressbar" [style.width]="sanitizer.bypassSecurityTrustStyle(((complianceItem.ForgivenCount / complianceItem.TotalUserCount) * 100) + '%')" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'Forgiven: ' + complianceItem.ForgivenCount"></div>
                </div>
            </div>
            <div *ngIf="printMode" class="col-8">
                <div class="row">
                    <div class="col-6">Approved:</div>
                    <div class="col-6">{{complianceItem.ApprovedCount || 0}}</div>
                </div>
                <div class="row">
                    <div class="col-6">Pending:</div>
                    <div class="col-6">{{complianceItem.PendingCount || 0}}</div>
                </div>
                <div class="row">
                    <div class="col-6">Waiting On User:</div>
                    <div class="col-6">{{complianceItem.WaitingOnUserCount || 0}}</div>
                </div>
                <div class="row">
                    <div class="col-6">Expiring:</div>
                    <div class="col-6">{{complianceItem.ExpiringCount || 0}}</div>
                </div>
                <div class="row">
                    <div class="col-6">Expired:</div>
                    <div class="col-6">{{complianceItem.ExpiredCount || 0}}</div>
                </div>
                <div class="row">
                    <div class="col-6">Disapproved:</div>
                    <div class="col-6">{{complianceItem.DisapprovedCount || 0}}</div>
                </div>
                <div class="row">
                    <div class="col-6">Forgiven:</div>
                    <div class="col-6">{{complianceItem.ForgivenCount || 0}}</div>
                </div>
                <div class="row">
                    <div class="col-6">Total:</div>
                    <div class="col-6">{{complianceItem.TotalUserCount || 0}}</div>
                </div>
            </div>
        </div>
        <div class="row push-down">
            <div class="col-sm-12 word-wrap">
                <strong>Description:</strong>
                <p>{{ complianceItem.Description }}</p>
            </div>
        </div>
        <div *ngIf="!printMode" class="row">
            <div class="col-sm-12 word-wrap">
                <strong>Instructions:</strong>
                <div class="instructions" [innerHtml]="ItemInstructionsSafeHtml"></div>
            </div>
        </div>
        <div *ngIf="!printMode" class="row">
            <div class="col-sm-12">
                <strong>Resource Links</strong>
                <ul style="margin-bottom: 15px;" class="resourceList">
                    <li *ngFor="let resource of complianceItem.Resources" class="resource-link"><a [href]="resource.Link" target="_blank" [innerHtml]="resource.Alias"></a></li>
                    <li *ngIf="complianceItem.Resources.length === 0">-</li>
                </ul>
            </div>
        </div>
        <div *ngIf="!printMode" class="row">
            <div class="col-sm-12">
                <strong>Documents</strong>
                <ul>
                    <li *ngFor="let attachment of complianceItem.Attachments"><i class="fas fa-paperclip"></i> <button type="button" class="btn btn-link" (click)="viewAttachement(attachment)">{{ attachment.FileName }}</button></li>
                    <li *ngIf="complianceItem.Attachments.length === 0">-</li>
                </ul>
            </div>
        </div>
        <div class="row" *ngIf="complianceItem.QfmID !== ''">
            <div class="col-sm-12" style="margin-top: 15px;">
                <strong>Questionnaire Preview</strong>
                <div>
                        <button type="button" *ngIf="!printMode" class="btn btn-link text-truncate text-start d-inline-block w-100" (click)="previewQuestionnaire()">{{ complianceItem.QfmDisplayTitle }}</button>
                        <div *ngIf="printMode" class="text-truncate d-inline-block w-100">{{ complianceItem.QfmDisplayTitle }}</div>
                </div>
            </div>
        </div>
    </div>
    <div [ngClass]="getColumnWidths()">
        <div class="row">
            <div class="col-md-12 col-lg-8">
                <div class="row push-down">
                    <div *ngIf="hasItemPackets()" >
                      <div [ngClass]="getColumnWidths()"><strong>Item Packets:</strong></div>
                      <div [ngClass]="getColumnWidths()">
                        <item-packet-pills [entries]="complianceItem.ItemPackets"></item-packet-pills>
                    </div>
                </div>
                <div class="row push-down">
                    <div [ngClass]="getColumnWidths()"><strong>Private:</strong></div>
                    <div [ngClass]="getColumnWidths()">{{ complianceItem?.IsPrivate ? 'On' : 'Off' }}</div>
                </div>
                <div class="row push-down">
                    <div [ngClass]="getColumnWidths()"><strong>Compliance Cycle Type:</strong></div>
                    <div [ngClass]="getColumnWidths()">{{ complianceItem.ItemType === CycleType.ITEM ? 'Item Timeline' : 'User Timeline' }}</div>
                </div>
                <div class="row">
                    <div [ngClass]="getColumnWidths()"><strong>Sub Type:</strong></div>
                    <div [ngClass]="getColumnWidths()">{{ complianceItem.SubType | itemSubtype }}</div>
                </div>
                <div class="row push-down" *ngIf="complianceItem.ItemType === CycleType.ITEM">
                    <div [ngClass]="getColumnWidths()"><strong>Start Date:</strong></div>
                    <div [ngClass]="getColumnWidths()">{{ complianceItem.StartDate | date:'MM/dd/yyyy' }}</div>
                </div>
                <div class="row push-down" *ngIf="complianceItem.ItemType === CycleType.ITEM">
                    <div [ngClass]="getColumnWidths()"><strong>End Date:</strong></div>
                    <div [ngClass]="getColumnWidths()">{{ complianceItem.EndDate | date:'MM/dd/yyyy' }}</div>
                </div>
                <div class="row push-down">
                    <div [ngClass]="getColumnWidths()"><strong>Recurrence:</strong></div>
                    <div [ngClass]="getColumnWidths()">
                            <div class="form-group" *ngIf="complianceItem.Recurrence !== null">
                                <span *ngIf="complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.WEEK">
                                    Recurs every {{ complianceItem.Recurrence.RecurrencePattern.WeekSeparationCount }} week(s)<span *ngIf="complianceItem.Recurrence.RecurrencePattern.Weekday !== 0"> on {{ complianceItem.Recurrence.RecurrencePattern.Weekday | weekdayDisplay }}</span>.</span>
                                <span *ngIf="complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.MONTH && complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.DAYOFMONTH">
                                    Day {{ complianceItem.Recurrence.RecurrencePattern.DaySeparationCount }} of every {{ complianceItem.Recurrence.RecurrencePattern.MonthSeparationCount }} month(s). </span>
                                <span *ngIf="complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.MONTH && complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.WEEKDAYOFMONTH">
                                    The {{ complianceItem.Recurrence.RecurrencePattern.WeekdayInterval | weekdayIntervalDisplay }} {{ complianceItem.Recurrence.RecurrencePattern.Weekday | weekdayDisplay }} of every {{ complianceItem.Recurrence.RecurrencePattern.MonthSeparationCount }} month(s). </span>
                                <span *ngIf="complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.MONTH && complianceItem.Recurrence.RecurrencePattern.OccurrenceType === 0">
                                    Recurs every {{ complianceItem.Recurrence.RecurrencePattern.MonthSeparationCount }} month(s).</span>
                                <span *ngIf="complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.YEAR">
                                    Recur every {{ complianceItem.Recurrence.RecurrencePattern.YearSeparationCount }} year(s)
                                    <span *ngIf="complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.MONTHDATE"> on {{ complianceItem.Recurrence.RecurrencePattern.Month | monthDisplay }} {{ complianceItem.Recurrence.RecurrencePattern.Date }} through {{ complianceItem.Recurrence.EndDate  | monthDayDisplay}}</span>
                                    <span *ngIf="complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.WEEKDAYOFMONTH"> on the {{ complianceItem.Recurrence.RecurrencePattern.WeekdayInterval | weekdayIntervalDisplay }} {{ complianceItem.Recurrence.RecurrencePattern.Weekday | weekdayDisplay }} of {{ complianceItem.Recurrence.RecurrencePattern.Month | monthDisplay }} through {{ complianceItem.Recurrence.EndDate  | monthDayDisplay}}</span>
                                . </span>
                                <span *ngIf="complianceItem.Recurrence.CompletionType === CompletionType.NONE">Recurrence does not end.</span>
                                <span *ngIf="complianceItem.Recurrence.CompletionType === CompletionType.ENDAFTER">Recurrence ends after {{ complianceItem.Recurrence.MaxNumberOfOccurrences }} reccurrences.</span>
                                <span *ngIf="complianceItem.Recurrence.CompletionType === CompletionType.ENDBY && complianceItem.Recurrence.EndBy !== null">Recurrence ends by {{ complianceItem.Recurrence.EndBy| date: 'MM/dd/yyyy' }}.</span>
                            </div>
                            <div class="form-group" *ngIf="complianceItem.Recurrence === null">
                                Not Applicable
                            </div>
                    </div>
                </div>
                <div class="row">
                    <div [ngClass]="getColumnWidths()"><strong>Person of Contact:</strong></div>
                    <div [ngClass]="getColumnWidths()">
                        <ul class="assigned-users">
                            <li *ngFor="let assignedUser of  complianceItem.AssignedUsers | propertyFilter:{ Type: UserAssignment.CONTACTUSER }">
                                {{ assignedUser.FirstName }} {{ assignedUser.LastName }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row push-down">
                    <div [ngClass]="getColumnWidths()"><strong>Watchers: </strong></div>
                    <div [ngClass]="getColumnWidths()">
                        <ul class="assigned-users">
                            <li *ngFor="let assignedUser of  complianceItem.AssignedUsers | propertyFilter:{ Type: UserAssignment.WATCHER }">
                                {{ assignedUser.FirstName }} {{ assignedUser.LastName }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row push-down">
                    <div [ngClass]="getColumnWidths()"><strong>Approval Stages:</strong></div>
                    <div [ngClass]="getColumnWidths()">
                        <div class="row" *ngFor="let verificationStage of complianceItem.VerificationStages">
                            <div class="col-sm-12">
                                <ng-template #approverContent>
                                    <ul class="assigned-users">
                                        <li *ngFor="let assignedUser of verificationStage.Approvers">
                                            {{ assignedUser.FirstName }} {{ assignedUser.LastName }}
                                        </li>
                                        <li *ngIf="verificationStage.Approvers.length === 0">None</li>
                                    </ul>
                                </ng-template>
                                {{ verificationStage.StageName }}
                                <i class="fas fa-check-circle" aria-hidden="true"
                                    [ngbPopover]="approverContent"
                                    popoverTitle="Approvers"
                                    triggers="mouseenter:mouseleave"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row push-down">
                    <div [ngClass]="getColumnWidths()"><strong>User Requirements:</strong></div>
                    <div [ngClass]="getColumnWidths()">
                        <div class="row" >
                            <div class="col-sm-12">
                                <ul class="assigned-users">
                                    <li *ngIf="complianceItem.NoTeacherRequirements">
                                        Nothing Required of User
                                    </li>
                                    <li *ngIf="complianceItem.QfmRequired">Questionnaire Required</li>
                                    <li>{{EvidenceRequirements}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-lg-12">
                <div class="row push-down">
                    <div class="col-sm-12"><strong>Reminders:</strong></div>
                </div>
                <div class="row" *ngFor="let reminder of reminders.controls">
                    <div class="col-sm-12">{{ reminder | itemReminderSummary }}</div>
                </div>
            </div>
            <div class="col-md-4 col-lg-12 mt-3" *ngIf="complianceItem?.FlexDetails?.Applicable">
                <edl-time-tracking-summary
                    [details]="complianceItem?.FlexDetails"
                ></edl-time-tracking-summary>
            </div>
            <div class="col-md-4 col-lg-12 mt-3" *ngIf="isAct48Enabled()">
              <div class="row push-down">
                  <div class="col-sm-12"><strong>Act 48:</strong></div>
              </div>
              <div class="row">
                  <div class="col-sm-12">{{a48HelpersService.getHoursOrCreditsFullLabel(complianceItem.Act48Detail.ActivityType)}}: {{complianceItem.Act48Detail.Hours}}</div>
                  <div class="col-sm-12">Provider: {{complianceItem.Act48Detail.Provider}}</div>
                  <div class="col-sm-12" *ngIf="A48Labels.AUNLabel">AUN: {{A48Labels.AUNLabel}}</div>
                  <div class="col-sm-12">Activity Type: {{A48Labels.ActivityType}}</div>
                  <div class="col-sm-12">Course Type: {{A48Labels.CourseType}}</div>
                  <div class="col-sm-12" *ngIf="A48Labels.CollegeCreditType">CollegeCreditType: {{A48Labels.CollegeCreditType}}</div>
                  <div class="col-sm-12" *ngIf="complianceItem.Act48Detail.ParaApplicable">CEC Performance Based Standard: {{A48Labels.CECPerformanceStandard}}</div>
              </div>
          </div>
        </div>
    </div>

</div>
